import React from 'react';
import { MenuItem } from '@mui/material';
import MainMenuItemContent from './MainMenuItemContent';
var MainMenuItem = function (_a) {
    var type = _a.type, icon = _a.icon, label = _a.label, isSelected = _a.isSelected, onClick = _a.onClick;
    var handleClick = function (e) { return onClick && onClick(type); };
    return (React.createElement(MenuItem, { onClick: handleClick, classes: { root: "mainMenu__menuItem " + (isSelected && 'mainMenu__menuItem--selected') } },
        React.createElement(MainMenuItemContent, { icon: icon, label: label, isSelected: isSelected })));
};
export default MainMenuItem;
//# sourceMappingURL=MainMenuItem.js.map